import React from "react";
import ReactDOM from "react-dom";
import { CssBaseline } from "@mui/material";
import "./index.css";
import App from "./App";
import { Provider } from "mobx-react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CommonStore } from "./Store";
import { red, yellow, lightBlue } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    warning: {
      main: yellow[500]
    },
    info: {
      main: lightBlue[50]
    }
  }
})

const Root = (
  <Provider store={CommonStore.message}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);
ReactDOM.render(Root, document.getElementById("root"));
